module.exports = __webpack_public_path__ + "static/img/menu2.ac6cf92.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu2.png
// module id = Mqir
// module chunks = 45